import { EnvConfig, PROD_CONFIG } from './prod'

export const DEV_CONFIG: EnvConfig = {
  ...PROD_CONFIG,
  domain: 'localhost:3000',
  googleAnalyticsId: 'G-NNZTB6X0JF',
  firebaseConfig: {
    apiKey: 'AIzaSyBvzb6DVHVs5lqEbamX3dVTRhgqKogQ7ig',
    authDomain: 'axel-predict.firebaseapp.com',
    projectId: 'axel-predict',
    region: 'us-central1',
    storageBucket: 'axel-predict.firebasestorage.app',
    privateBucket: 'axel-predict-private',
    messagingSenderId: '130455159968',
    appId: '1:130455159968:web:b0b1f5385e63065eb575c5',
    measurementId: 'G-NNZTB6X0JF',
  },
  cloudRunId: '',
  cloudRunRegion: 'uc',
  amplitudeApiKey: '',
  supabaseInstanceId: 'yuyzkcqkscxpnjfztrpu',
  supabaseAnonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl1eXprY3Frc2N4cG5qZnp0cnB1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY1OTE1MzYsImV4cCI6MjA4MjE2NzUzNn0.MrnRFouWAkG8huxnjcxzIdHipEEPdO2vQ8_VO0FUfEM',
  supabasePublishableKey: 'sb_publishable_vt_UC6Xjownb3W84TlTU5g_a2d5QNny',
  supabaseUrl: 'https://yuyzkcqkscxpnjfztrpu.supabase.co',
  twitchBotEndpoint: '',
  apiEndpoint: 'localhost:8088',
  expoConfig: {},
  adminIds: [],
}
